import React, { useState, useContext, useEffect } from 'react'
import { VistaEmpresasContext } from './VistaEmpresasAdmin'
import { Oval } from 'react-loader-spinner'
import ModalEmpleadoConsul from '../../Modales/Admin/consultora/ModalEmpleadoConsul'
import { useAdmin } from '../../../context/AdminContext';
import { AreaContext } from '../../../context/AreaContext';

export const listaEmpleadoConsulContext = React.createContext()

function ListaEmpleadosConsul() {

    const { user, idEmpresa } = useContext(VistaEmpresasContext)

    const { areas, setAreas } = useContext(AreaContext)

    const { empleados, loadingEmpleado, errorEmpleado, fetchArea, setErrorArea } = useAdmin()
    
    const [modalEmpleado, setModalEmpleado] = useState(false)
    const [objEmpleado, setObjEmpleado] = useState(null)

    const [idEmpleado, setIdEmpleado] = useState(null)

    useEffect(()=>{
        fetchArea(user, idEmpresa)
        .then(res => {
            if(res.status !== 0){
                setErrorArea(res.codeError)
            } else {
                setAreas(res.objeto)
            }
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[idEmpresa])

    const handleModalEmpleado = () => {
        setModalEmpleado(true)
    }
    
    const handleModalEditEmpleado = (id) => {
        const obj = empleados.find((e) => e.id_empleado === id)
        setObjEmpleado(JSON.stringify(obj))
        setIdEmpleado(id)
        setModalEmpleado(true)
    }

    return (
        <>
            <listaEmpleadoConsulContext.Provider value={{ user, idEmpresa, idEmpleado, setIdEmpleado, objEmpleado, setObjEmpleado }}>
                <ModalEmpleadoConsul show={modalEmpleado} onHide={()=>setModalEmpleado(false)} />
                {loadingEmpleado ? (
                    <div className='loading__ListaUsuariosConsul my-3 d-flex flex-column align-items-center justify-content-center'>
                        <Oval
                            visible={true}
                            height="40"
                            width="40"
                            color="#0d6efd"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                        <p className='fw-medium m-0 p-0'>Loading...</p>
                    </div>
                ) : (
                    <>
                    {errorEmpleado ? (
                        <div className='error__ListaUsuariosConsul py-4 d-flex flex-column align-items-center justify-content-center rounded-3'>
                            <h3 className='text-danger fw-semibold mb-2'>Oops!</h3>
                            <p className='m-0 p-0'>{errorEmpleado}</p>
                        </div>
                    ) : (
                        <>
                        {empleados.length === 0 ? (
                            <div className='container__usuarios--empty py-4 d-flex flex-column align-items-center rounded-3'>
                                <h3 className='text-green'>No tienes empleados aún.</h3>
                                <button onClick={handleModalEmpleado} className='btn btn-sm btn-success rounded-pill px-3 fw-medium'>+ Agregar empleado</button>
                            </div>
                        ) : (
                            <div className='container__usuarios'>
                                <div className='d-flex flex-row align-items-center mb-3'>
                                    <h4 className='text-green m-0 pe-3 '>Empleados</h4>
                                    <button onClick={handleModalEmpleado} className='btn btn-sm btn-outline-success rounded-pill px-3 fw-medium'>+ Agregar empleado</button>
                                </div>
                                <div className='table__customU'>
                                    <div className='table__customU__header'>
                                        <div className='table__customU__cell cellU__buttons fw-bold text-green'></div>
                                        <div className='table__customU__cell cellU__id fw-bold text-center text-green'>#</div>
                                        <div className='table__customU__cell cellU__name fw-bold text-green'>Nombre</div>
                                        <div className='table__customU__cell cellU__mail fw-bold text-green'>Email</div>
                                        <div className='table__customU__cell cellU__fecha fw-bold text-green'>Fecha de creación</div>
                                        <div className='table__customU__cell cellU__puesto fw-bold text-green'>Puesto</div>
                                        <div className='table__customU__cell cellU__area fw-bold text-green'>Área</div>
                                    </div>
                                    <div className='table__customU__body'>
                                    {empleados.map((e,i) => {
                                        return <div key={i} className='d-flex flex-row'>
                                            <div className='table__customU__row'>
                                                <div className='table__customU__cell cellU__buttons'>
                                                    <button onClick={()=>handleModalEditEmpleado(e.id_empleado)} className='btn__ico--g btn border-0 p-0 btn__edit--icon'><i className="bi bi-pencil"></i></button>
                                                </div>
                                                <div className='table__customU__cell cellU__id fw-bold text-center text-green'>{e.id_empleado}</div>
                                                <div className='table__customU__cell cellU__name'>{e.nombre}</div>
                                                <div className='table__customU__cell cellU__mail'>{e.mail}</div>
                                                <div className='table__customU__cell cellU__fecha'>{e.fecha_de_creacion}</div>
                                                <div className='table__customU__cell cellU__puesto'>
                                                    {e.fk_puesto === 1 && "Administrador"}
                                                    {e.fk_puesto === 2 && "Consultora"}
                                                    {e.fk_puesto === 3 && "Gerente"}
                                                    {e.fk_puesto === 4 && "Jefe de Área"}
                                                    {e.fk_puesto === 5 && "Empleado"}
                                                    {e.fk_puesto === 6 && "Aprobador de muestras"}
                                                    {e.fk_puesto === 7 && "Auditor externo"}
                                                </div>
                                                <div className='table__customU__cell cellU__area'>
                                                    {areas.find(a => a.id_area === e.fk_area)?.nombre_del_Area}
                                                </div>
                                            </div>
                                        </div>
                                    })}
                                    </div>
                                </div>
                            </div>
                        )}
                        </>
                    )}
                    </>
                )}
            </listaEmpleadoConsulContext.Provider>
        </>
    )
}

export default ListaEmpleadosConsul